import { PppPage } from './PppPage';

export function AdminPppPage() {
  return <PppPage adminMode />;
}
